// extracted by mini-css-extract-plugin
export default {"description":"style_description__Ipvnk","fade-in":"style_fade-in__fmrwk","top":"style_top__wBQ3U","image":"style_image__Yprb8"};